
import Vue from 'vue'

export default Vue.extend({
  name: 'DefaultPreview',
  props: {
    color: {
      required: false,
      default: '#ffffff',
      type: String,
    },
  },
})
